import DetectIp from './DetectIP'
import SaveParamsClient from './SaveParamsClient'
import UploadLogoCliente from './UploadLogoCliente'

export const DetectIpService = DetectIp
export const SaveParamsClientService = SaveParamsClient
export const UploadLogoClienteService = UploadLogoCliente
